import * as types from './types'

// 设置用户信息
export const setUser = ({ commit, state }, res) => {
  commit(types.SET_USER, res)
}



// WEBPACK FOOTER //
// ./src/store/actions.js